import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { Recommendation } from '~src/recommendations/components/spaces/tooltips/Recommendation';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { EntityLinkProps } from '~src/spacesPlatform/components/tooltip/EntityLink';
import { LocationField } from '~src/spacesPlatform/components/tooltip/LocationField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { RelatedEntity } from '~src/spacesPlatform/components/tooltip/RelatedEntity';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, getPersonalSpaceLink, getProjectLink, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { User } from '~src/spacesPlatform/components/tooltip/User';
import { isRecommendationType } from '~src/spacesPlatform/models/ContentType';
import { Tags } from '~src/tags/components/tooltips/Tags';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';
import { IViewInfo } from '~src/views/models/IViewInfo';

export function ViewTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;

  // Views api does not return owner property at the top level, but rather adds to the workbook
  const workbook = (content as IViewInfo).workbook;
  const owner: IUserInfo = content.owner || (workbook && workbook.owner);
  const workbookLink: EntityLinkProps = workbook ? {
    href: urls.workbookUrl(workbook.id),
    iconImagePath: imgPath('workbook_content_type_small.svg'),
    iconHeightOverride: 18,  // the icon height is 18 just for workbooks :|
    name: workbook.name
  } : null;

  const projectLink = workbook ? getProjectLink(workbook.project, urls) : null;
  const personalSpaceLink = getPersonalSpaceLink(urls);
  const locationType = workbook?.location?.type;
  const ownerId = owner?.id;
  return (
    <Tooltip>
      <Name name={props.content.name} />
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      {isRecommendationType(props.content.contentType) && <Recommendation explanationType={content.explanationType} users={content.similiarUsers} urls={urls}/>}
      <Tags tags={content.tags} />
      { workbook && <RelatedEntity label={Messages.workbook()} link={workbookLink} /> }
      <LocationField inProjectSpace={props.inProjectSpace} inPersonalSpace={props.inPersonalSpace}
        locationType={locationType} projectLink={projectLink} personalSpaceLink={personalSpaceLink} contentOwnerId={ownerId}/>
      { owner && <User user={owner} label={Messages.owner()} urls={urls} /> }
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
